import React from "react";
import "../styles/WhatStandOut.scss";


function LonavalaInvestment() {
    const cards = [
        {
            title: "Lifestyle Drivers",
            content:
                `Established Luxury Market – A serene retreat for HNIs & celebrities.
                Strong Demand for Second Homes – Preferred weekend getaway for Mumbai & Pune residents.
                Lifestyle Benefits – Nature, history, and endless recreation.`,
            // img: graph,
        },
        {
            title: "Investment Drivers",
            content: `Growing Primary Home Market – Rising demand for peaceful living.
            Infrastructure Boost – Expressway & Navi Mumbai Airport ensure connectivity.
            Steady Appreciation – Avg. ~₹12,011/sq.ft with consistent growth.
            Attractive Returns – Villa rentals yield 4–6% annually.`,
            // img: express,
        },

    ];

    return (
        <div className="what-stand-out">
            <h2 className="heading">
                Lonavalley = smart + aspirational.
            </h2>

            <p>A destination loved by HNIs and celebrities, Lonavala is more than a weekend escape — it’s one of India’s most stable and rewarding real estate markets.</p>

            <div className="container">

                <div className="cards-container">
                    {cards.map((card, index) => (
                        <div className="card" key={index}>
                            {/* {card.img && (
                                <div className="card-image">
                                    <img src={card.img} alt={card.title} />
                                </div>
                            )} */}
                            {card.icon && <div className="card-icon">{card.icon}</div>}
                            <h3 className="card-title">{card.title}</h3>
                            <p className="card-content">
                                {card.content.split('\n').map((line, index) => (
                                    <span key={index}>
                                        {line}
                                        <br />
                                    </span>
                                ))}
                            </p>

                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default LonavalaInvestment;
